import Logo from "../assets/img/sandbox.svg";
import Poweredby from "../assets/img/BackrrFullGrey.png";
import favicon from "../assets/img/favicon.png";

const Initial = {
  branding: {
    favicon:favicon,
    logo: Logo,
    poweredbylogo: Poweredby,
  },
  app:{
    // iosApp:"",
    // androidApp:""
  },
  organization:{
    title:"Zenith Venture",
    sub_title:"My Zenith Venture",
    name:"ZVAF",
    email:"notifications@backrr.com",
    aboutus:"https://backrr.com/",
    contactus:"https://backrr.com/",
    terms_of_use:"https://backrr.com/",
  },
  theme: {
    mainColor:"#f7aa1d",    //set the button color 
    // mainColor:"#2B2D42",   //set the button color 
  },
  flow: {
    logiFlow1:true,
    logiFlow2:true,
    registerFlow1:true,
    registerFlow2:false,
  },
  sidebar: {
    deals:true,
    my_profile:true,
    portfolio:true,
    favorites:true,
    statement_of_account:true,
    aboutus:true,
    contactus:true,
  },
  home:{
    deal_flow:true,
    my_portfolio:true,
  },
};

// Inject CSS variables directly into the document head
const setCSSVariables = () => {
  const style = document.createElement("style");
  style.innerHTML = `
    :root {
      --main-color: ${Initial.theme.mainColor};
    }
  `;
  document.head.appendChild(style);
};

// Call the function to apply styles
setCSSVariables();
window.Initial = Initial;

export default Initial;
